<div class="flex flex-col gap-4">
  <mat-form-field>
    <mat-label>Ceturksnis</mat-label>
    <mat-select #quarterSelect (selectionChange)="onQuarterSelected($event.value)">
      <div class="flex items-center justify-center">
        <button mat-icon-button type="button" (click)="change(-1)">
          <mat-icon> keyboard_arrow_left</mat-icon>
        </button>
        {{ year }}
        <button mat-icon-button type="button" (click)="change(1)">
          <mat-icon> keyboard_arrow_right</mat-icon>
        </button>
      </div>
      @for (quarter of quarters; track $index) {
        <mat-option class="flex w-full items-center justify-center" [value]="quarter.startMonth">
          {{ quarter.label }} ({{ quarter.months }})
        </mat-option>
      }
    </mat-select>
    <button mat-icon-button matSuffix type="button" aria-label="Notīrīt filtru" (click)="clearDate(quarterSelect); $event.stopPropagation()">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-form-field>
</div>
